var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPaperPlane({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 23,
    height: 23,
    viewBox: "0 0 23 23",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9.09787 13.5948L17.8697 4.82294M5.18014 7.80601L15.9324 4.22192C17.5011 3.69901 18.9936 5.19145 18.4706 6.76018L14.8866 17.5124C14.3212 19.2084 11.9876 19.3743 11.188 17.7753L9.39693 14.193C9.20276 13.8047 8.88787 13.4898 8.49952 13.2956L4.91729 11.5045C3.31828 10.705 3.48413 8.37134 5.18014 7.80601Z",
    stroke: "white",
    strokeWidth: 1.38462,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPaperPlane);
export default __webpack_public_path__ + "static/media/paper-plane.4e8ddf3d5552d27efdaba55d9f054e73.svg";
export { ForwardRef as ReactComponent };